<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper default-page bg-white-imp">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button  class="button is-flex nav-back">
          </button>
          <h1 class="title has-text-black">Guest User</h1>
        </div>
      </app-header>
      <main class="content-wrapper">
        <section class="section section-content">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-8-tablet">
                <div class="verify-token">
                  <loading v-if="showLoading"></loading>
                  <p :class="'text-center ' + (showLoading ? '': 'loaded')" v-text="msg"></p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import Helpers from '@/Components/Helpers/Helpers';
import VboutApis from '@/Components/Controllers/VboutApis';

export default {
  name: 'LoginWithToken',
  data() {
    return {
      msg: 'Please Wait. We are verifying your details....',
      location: {},
      showLoading: true,
    };
  },

  computed: {
    ...mapGetters({
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_userId: "getLoggedInUserId",   
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_businessProfile: "businessprofile/detail", 
    })
  },

  mounted() {
    let token = this.$route.query.token;
    if(token){
      // if(this.$route.query['hide-map'] == 'true'){
      //   this.va_setLocationQueries({
      //     'hide-map': true
      //   })
      // }
      this.loginWithToken(token); 
    } else {
      this.$router.push({ 
        name: 'HomePage', 
        params: { business_slug: this.$route.params.business_slug },
        query: Helpers.refineQuery(['token'],this.$route.query)
      });
    }
  },

  methods: {
    /**
     * Fetch location detail from location ID
     */
    async fetchLocation(locationId){
      let res = await LocationApis.fetchByID(locationId); // 0ebc63b0-e0aa-46ce-98ab-e3af6144a08d missjones hard coded
      if(res.status == 200){
        this.location = res.data.payload;
      } 
    },

    /**
     * Login via token, clear if  user logged in
     */
    async loginWithToken(token) {
      const self = this;
      let res = await LoginApis.loginWithToken({ token: token });
      if(res.status != 200){
        this.msg = res.response.data.msg;
        this.showLoading = false;
      } else {
        this.msg = 'Token Verified. Logging in...';
        // Remove existing data
        await this.$store.dispatch("REMOVE_APP_DATA");
        // Set new user values
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
        this.$store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: '',
          remember: false,
        });   

        // If user has email_verification_status = true tag it 
        if(res.data.payload.email_verification_status){
          VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'verified',
          }, this.location.id);
        }
        // casl_opt_in as marketing notification
        if(res.data.payload.marketing_notification){
          VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'casl_opt_in',
          }, this.location.id);
        }

         // Fetch user loyalty points
        if( this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
          await this.va_setUserLoyalityObj({
            user_id: this.vg_userId, 
            business_id: this.vg_businessProfile.id,
          });
        }

        // Fetch order history
        let orderHistory = await OrderHistoryApis.fetch(1);
        if(orderHistory.status == 200) {
          this.va_setAllOrders(orderHistory.data.payload);
        }
        // Fetch user fav products
        UserApis.fetchFavProducts();
        // Fetch user fav locations
        UserApis.fetchFavLocations();
        await this.fetchLocation(this.$route.params.locationId);
        if(!_.isEmpty(this.location) && this.location.id != ''){
          await CartApis.locationCart(this.location.id, Helpers.getLocationCartFullUrl(this));
        }
        this.msg = 'Successfully logged in...';
        this.$router.push({ 
          name: 'StoreLanding', 
          params: { 
            business_slug: this.$route.params.business_slug, 
            store_slug: this.location.slug 
          }, 
          query: Helpers.refineQuery(['token'],this.$route.query),
        })
      }
    },

    ...mapActions({
      va_setLocationQueries: "location/setGuestLandedQueries",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })

  },
};
</script>

<style scoped>
.verify-token {
    position: relative;
}
.verify-token p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
}
p.text-center.loaded {
  bottom: 0;
  position: relative;
  margin-top: 80px;
}
</style>